'use strict';
const angular = require('angular');

const uiRouter = require('angular-ui-router');

import routes from './style-edit.routes';

export class StyleEditComponent {
  constructor(SettingsService, Auth, dialogs) {
    'ngInject';

    this.SettingsService = SettingsService;

    this.dialogs = dialogs;

    this.styleSettingTemplate = {
      name: '$css',
      description: '',
      data: {
        css: ""
      },
      meta: {
        creationUser: Auth.getCurrentUserSync()._id,
        active: true
      }
    };

    this.styleSetting = angular.copy(this.styleSettingTemplate);

    this.SettingsService.getByName({name: '$css'}, data => {
      this.styleSetting = data;
    }, err => {
      this.styleSettingIsNew = true;
    });

    CodeMirror.defineOption("matchBrackets", true);
    CodeMirror.defineOption("autoCloseBrackets", true);
    CodeMirror.defineOption("lineWrapping", true);
    CodeMirror.defineOption("tabSize", 2);
    CodeMirror.defineOption("mode", "css");
    CodeMirror.defineOption("gutters", ["CodeMirror-lint-markers"]);
    CodeMirror.defineOption("lint", true);
    CodeMirror.defineOption("styleActiveLine", true);
    CodeMirror.defineOption("lineNumbers", true);
  }

  create(form) {
    this.submitted = true;
    this.sendFailure = false;

    var that = this;

    if (form.$valid) {

      var onSuccess = () => {
        this.settings = angular.copy(this.settingsTemplate);
        this.submitted = false;

        var dlg = this.dialogs.notify("Success", "The styles have been changed successfully");
        dlg.result.then(() => {
        });
      };

      var onError = err => {
        this.sendFailure = true;
      };

      if (this.styleSettingIsNew) {
        this.SettingsService.save(this.styleSetting, onSuccess, onError);
      } else { // Create new settings
        this.SettingsService.update({id: this.styleSetting._id}, this.styleSetting, onSuccess, onError);
      }
    }
  }
}

export default angular.module('conduu.ap.styles.edit', [uiRouter])
  .config(routes)
  .component('styleEdit', {
    template: require('./style-edit.html'),
    controller: StyleEditComponent,
    controllerAs: 'ctrl'
  })
  .name;



// WEBPACK FOOTER //
// ./client/~ap/app/styles/edit/style-edit.component.js